module.exports = __webpack_public_path__ + "static/img/40016 (4).54f86a2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40016 (4).webp
// module id = z3ER
// module chunks = 14